import React, { Component } from "react";
import { PageMode } from "../../../../utils/constant";
// import Fup from "../../../../services/FUP";
import InputSelect from "../../../../components/InputSelect";
import InputField from "../../../../components/InputField";

// const FupService = new Fup();
export default class Form extends Component {
  _isMounted = true;

  constructor(props) {
    super(props);
    this.defaultValue = {
      province_id: { value: "", isValid: true, message: "" },
      district_id: { value: "", isValid: true, message: "" },
      fasyankes_id: { value: "", isValid: true, message: "" },
      ktp: { value: "", isValid: true, message: "" },
      name: { value: "", isValid: true, message: "" },
      date_of_taking_first_medicine: { value: "", isValid: true, message: "" },
      day_to: { value: "", isValid: true, message: "" },
      date_visit: { value: "", isValid: true, message: "" },
      sympthom: { value: "", isValid: true, message: "" },
      sympthom_of_severe_malaria: { value: "", isValid: true, message: "" },
      body_temperature: { value: "", isValid: true, message: "" },
      microscopic_examination_results: {
        value: "",
        isValid: true,
        message: "",
      },
      parasyte_density: { value: "", isValid: true, message: "" },
      medication: { value: [], isValid: true, message: "" },

      provincies: [],
      districts: [],
      subdistricts: [],
      urbanvillages: [],
      fasyankes: [],
    };
    this.state = Object.assign({}, this.defaultValue);
  }

  componentDidMount() {
    let obj = Object.assign({}, this.defaultValue);
    if (this.props.mode === PageMode.edit) {
      const { data } = this.props;

      obj.year_report.value = data.year_report;
      obj.month_report.value = data.month_report;
      obj.province_id.value = data.province_id;
      obj.district_id.value = data.district_id;
      obj.fasyankes_id.value = data.fasyankes_id;
      obj.ktp.value = data.ktp;
      obj.name.value = data.name;
      obj.date_of_taking_first_medicine.value =
        data.date_of_taking_first_medicine;
      obj.day_to.value = data.day_to;
      obj.date_visit.value = data.date_visit;
      obj.sympthom.value = data.sympthom;
      obj.sympthom_of_severe_malaria.value = data.sympthom_of_severe_malaria;
      obj.body_temperature.value = data.body_temperature;
      obj.microscopic_examination_results.value =
        data.microscopic_examination_results;
      obj.parasyte_density.value = data.parasyte_density;
      obj.medication.value = data.medication;
    }

    this.setState(obj);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    const isValid = value ? true : false;
    this.setState({ ...this.state, [name]: { value, isValid, message: "" } });
  };

  render() {
    return (
      <div className="dashboard-wrapper">
        <div className="container mt-4">
          <h1 className="font-weight-bold title">Data Follow Up Pengobatan</h1>
          <p className="font-weight-bold d-flex justify-content-start">
            NOTE: <span className="text-danger">*(WAJIB DIISI)</span>
          </p>
          <div className="form-content">
            <div className="form-wrapper">
              <InputField
                label="NIK"
                name="nik"
                onChange={this.handleInputChange}
                value={this.state.ktp.value}
                placeholder="Masukkan NIK"
                isRequired={true}
              />

              <InputField
                label="Nama"
                name="name"
                onChange={this.handleInputChange}
                value={this.state.name.value}
                placeholder="Nama Pasien"
              />

              <InputField
                label="Tanggal Minum Obat Pertama"
                type="date"
                name="date_of_taking_first_medicine"
                onChange={this.handleInputChange}
                value={this.state.date_of_taking_first_medicine.value}
                placeholder="Tanggal Minum Obat Pertama"
                isRequired={true}
              />

              <InputSelect
                label="Hari Ke"
                name="day_to"
                onChange={this.handleInputChange}
                value={this.state.day_to.value}
                placeholder="Hari Ke"
                data={[
                  {value: 0, label: 'Hari - 0'},
                  {value: 1, label: 'Hari - 1'},
                  {value: 2, label: 'Hari - 2'},
                  {value: 3, label: 'Hari - 3'},
                  {value: 14, label: 'Hari - 14'},
                  {value: 28, label: 'Hari - 28'},
                  {value: 42, label: 'Hari - 42'},
                  {value: 90, label: 'Hari - 90 (Khusus Ovale atau Vivax'},
                  {value: 'Lainnya', label: 'Hari Lainnya'}
                ]}
                isRequired={true}
              />

              <div className="form-group">
                <label htmlFor="derajat_penyakit_malaria">
                  Masukkan jumlah hari
                  <sup className="text-danger">*</sup>
                </label>
                <input type="text" className="form-control" />
              </div>
              <div className="form-group">
                <label htmlFor="tanggal_kunjungan">
                  Tanggal kunjungan
                  <sup className="text-danger">*</sup>
                </label>
                <input type="date" className="form-control" />
              </div>
              <div className="form-group">
                <label htmlFor="gejala">Gejala</label>
                <select name="gejala" id="gejala" className="form-control">
                  <option value="" disabled selected>
                    Pilih
                  </option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="suhu_tubuh">Suhu Tubuh (Celcius)</label>
                <input
                  type="text"
                  name="suhu_tubuh"
                  id="suhu_tubuh"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="gejala_malaria_berat">
                  Gejala Malaria Berat
                </label>
                <select
                  name="gejala_malaria_berat"
                  id="gejala_malaria_berat"
                  className="form-control"
                >
                  <option value="" disabled selected>
                    Pilih
                  </option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="">
                  Hasil pemeriksaan mikroskopis (Bisa memilih lebih dari satu)
                </label>
                <div className="container">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="item">
                        <input
                          type="checkbox"
                          className="form-check-input mr-2"
                          id="parasitOne"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="parasitOne"
                        >
                          Negatif
                        </label>
                      </div>
                      <div className="item">
                        <input
                          type="checkbox"
                          className="form-check-input mr-2"
                          id="parasitTwo"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="parasitTwo"
                        >
                          P.falciparum
                        </label>
                      </div>
                      <div className="item">
                        <input
                          type="checkbox"
                          className="form-check-input mr-2"
                          id="parasitThree"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="parasitThree"
                        >
                          P.vivax
                        </label>
                      </div>
                      <div className="item">
                        <input
                          type="checkbox"
                          className="form-check-input mr-2"
                          id="parasitFour"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="parasitFour"
                        >
                          P.pmalariae
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="item">
                        <input
                          type="checkbox"
                          className="form-check-input mr-2"
                          id="parasitOne"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="parasitOne"
                        >
                          P.ovale
                        </label>
                      </div>
                      <div className="item">
                        <input
                          type="checkbox"
                          className="form-check-input mr-2"
                          id="parasitTwo"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="parasitTwo"
                        >
                          Mix
                        </label>
                      </div>
                      <div className="item">
                        <input
                          type="checkbox"
                          className="form-check-input mr-2"
                          id="parasitThree"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="parasitThree"
                        >
                          Probable Knowlesi
                        </label>
                      </div>
                      <div className="item">
                        <input
                          type="checkbox"
                          className="form-check-input mr-2"
                          id="parasitFour"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="parasitFour"
                        >
                          P.knowlesi
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="kepadatan_parasit">Kepadatan Parasit</label>
                <input
                  type="text"
                  name="kepadatan_parasit"
                  id="kepadatan_parasit"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label htmlFor="pengobatan">
                  Pengobatan<span className="text-danger">*</span>
                </label>
                <div className="row d-flex justify-content-between">
                  <div className="col-sm-6 align-self-center">
                    <p className="font-weight-bold">DHP Tablet</p>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group row">
                      <label
                        htmlFor="inputEmail3"
                        className="col-sm-4 col-form-label"
                      >
                        Jumlah Obat
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="email"
                          className="form-control"
                          id="inputEmail3"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row d-flex justify-content-between">
                  <div className="col-sm-6 align-self-center">
                    <p className="font-weight-bold">Primaquin Tablet</p>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group row">
                      <label
                        htmlFor="inputEmail3"
                        className="col-sm-4 col-form-label"
                      >
                        Jumlah Obat
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="email"
                          className="form-control"
                          id="inputEmail3"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row d-flex justify-content-between">
                  <div className="col-sm-6 align-self-center">
                    <p className="font-weight-bold">Kina Tablet</p>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group row">
                      <label
                        htmlFor="inputEmail3"
                        className="col-sm-4 col-form-label"
                      >
                        Jumlah Obat
                      </label>
                      <div className="col-sm-8">
                        <input type="text" className="form-control" id="text" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row d-flex justify-content-between">
                  <div className="col-sm-6 align-self-center">
                    <p className="font-weight-bold">Artesunat Injeksi</p>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group row">
                      <label
                        htmlFor="inputEmail3"
                        className="col-sm-4 col-form-label"
                      >
                        Jumlah Obat
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="email"
                          className="form-control"
                          id="inputEmail3"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row d-flex justify-content-between">
                  <div className="col-sm-6 align-self-center">
                    <p className="font-weight-bold">Kina Injeksi</p>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group row">
                      <label
                        htmlFor="inputEmail3"
                        className="col-sm-4 col-form-label"
                      >
                        Jumlah Obat
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="email"
                          className="form-control"
                          id="inputEmail3"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row d-flex justify-content-between">
                  <div className="col-sm-6 align-self-center">
                    <p className="font-weight-bold">Doksisklin</p>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group row">
                      <label
                        htmlFor="inputEmail3"
                        className="col-sm-4 col-form-label"
                      >
                        Jumlah Obat
                      </label>
                      <div className="col-sm-8">
                        <input
                          type="email"
                          className="form-control"
                          id="inputEmail3"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-action d-flex justify-content-end">
                <button className="btn btn-teal font-weight-bold">
                  Simpan Data
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
